import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Paginator } from 'primeng/paginator';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    standalone: false
})
export class PaginatorComponent implements OnChanges {
  @ViewChild('pg') paginator: Paginator;
  @Input() totalCount: number = 0;
  @Input() showFirstLastIcon : boolean = false;
  @Input() resetTrigger: number = 0;
  @Input() currentPage: number = 0;
  @Input() rowsPerPage: number = 20;
  @Output() selectedPage :EventEmitter<any> = new EventEmitter();
  hidePagination: boolean = true;
  first : number = 0;
  // currentPage: number = 0;
  ngOnChanges(changes: SimpleChanges) {
    if(changes ?.['totalCount']){
      this.totalCount = changes['totalCount'].currentValue || 0;
      this.calculatePages();
    }

    if (changes['resetTrigger']) {
      this.paginator?.changePageToFirst(new Event('reset'));
    }

    if (changes['currentPage']) {
      const pageIndex = this.currentPage;
      if (pageIndex > 0 ) {
        this.first = pageIndex * this.rowsPerPage;
      }else{
        this.first = 1;
      }
    }
  }

  calculatePages(){
    if(!Number.isNaN(this.totalCount) && !Number.isNaN(this.rowsPerPage) && (Number(this.totalCount) > Number(this.rowsPerPage))){
      this.hidePagination = false;
    }else{
      this.hidePagination = true;
    }
  }

  onPageChange(event : any){
    if(this.currentPage !== event?.page){
      this.selectedPage.emit(event);
    }
    this.currentPage = event?.page || 0;
  }
}
